import { useNavigate } from "react-router";
import { useState } from "react";
import { useLogin } from "@/api/hooks/mutations";
import { ApiError } from "@/api/client";

export function AdminLoginPage() {
  const navigate = useNavigate();
  const login = useLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError("");
    try {
      await login.mutateAsync({ email, password });
      navigate("/admin");
    } catch (err) {
      if (err instanceof ApiError) {
        if (err.status === 401) setError("Invalid email or password.");
        else if (err.status === 429) setError("Too many attempts — try again in a minute.");
        else setError(err.message || "Login failed.");
      } else {
        setError("Login failed.");
      }
    }
  }

  return (
    <div className="grid min-h-screen place-items-center px-6">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md rounded-2xl border border-border bg-surface p-9 shadow-lg"
      >
        <h1 className="text-2xl font-bold">Sign in</h1>
        <p className="mt-1.5 text-sm text-text-muted">
          Admin access only. Merchants and specialists don't need an account.
        </p>
        <div className="mt-6 flex flex-col gap-3.5">
          <label className="flex flex-col gap-1.5 text-sm font-medium">
            Email
            <input
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-md border border-border bg-surface px-3 py-2.5 text-sm outline-none focus:border-primary focus:shadow-[0_0_0_3px_var(--primary-soft)]"
            />
          </label>
          <label className="flex flex-col gap-1.5 text-sm font-medium">
            Password
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-md border border-border bg-surface px-3 py-2.5 text-sm outline-none focus:border-primary focus:shadow-[0_0_0_3px_var(--primary-soft)]"
            />
          </label>
          {error && (
            <div
              role="alert"
              className="rounded-md bg-danger-soft px-3 py-2 text-sm text-[#b91c1c]"
            >
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={login.isPending}
            className="mt-2 rounded-md bg-primary px-4 py-2.5 text-sm font-semibold text-white hover:bg-primary-hover disabled:opacity-60"
          >
            {login.isPending ? "Signing in…" : "Sign in"}
          </button>
        </div>
      </form>
    </div>
  );
}
